export const BOT_ENV = {
  TEST: {
    title: `Test`,
    value: 'test',
    placeholder: 'Base url. e.g. https://staging.haptik.ai',
  },
  PRODUCTION: {
    title: `Production`,
    value: 'production',
    placeholder: 'Base url. e.g. https://production.haptik.ai',
  },
};

export const speedValuesBasedOnTtsProvider = [
  {
    min: 0.7,
    max: 1.2,
    default: 1.0,
  },
  {
    min: 0.5,
    max: 2,
    default: 1.1,
  },
  {
    min: -50,
    max: 50,
    default: 0.0,
    step: 0.5,
  },
];
